import React, { useEffect, useState } from "react";
import { toast, ToastContainer } from "react-toastify";
import { useParams } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import img from "./all_bg.jpg";

// AACSB DATE RANGE
const START_DATE = new Date("2020-07-01");
const END_DATE = new Date("2026-09-30");

// Section schema
const SECTION_COLUMN_SCHEMA = {
  academic_journal_articles: [
    { key: "title", label: "Title" },
    { key: "journal_name", label: "Journal Name" },
    { key: "doi_link", label: "DOI Link" },
    { key: "quartile", label: "Quartile" },
    { key: "scopus_category", label: "Scopus Category" },
    { key: "abdc", label: "ABDC" },
    { key: "abs", label: "ABS" },
    { key: "wos_jif", label: "WoS JIF" },
    { key: "total_authors", label: "Total Authors" },
    { key: "author_position", label: "Author Position" },
    { key: "is_collaborative", label: "Collaborative?" },
    { key: "collaborative_authors", label: "Collaborative Authors" },
  ],

  book: [
    { key: "book_title", label: "Title" },
    { key: "publisher", label: "Publisher" },
    { key: "country", label: "Country" },
    { key: "publisher", label: "Publisher" },
    { key: "total_authors", label: "Total Authors" },
    { key: "author_position", label: "Author Position" },
    { key: "publisher", label: "Publisher" },
    { key: "is_collaborative", label: "Collaborative?" },
    { key: "collaborative_authors", label: "Collaborative Authors" },
  ],

  book_chapters: [
    { key: "chapter_title", label: "Chapter Title" },
    { key: "book_title", label: "Title" },
    { key: "publisher", label: "Publisher" },
    { key: "country", label: "Country" },
    { key: "publisher", label: "Publisher" },
    { key: "total_authors", label: "Total Authors" },
    { key: "author_position", label: "Author Position" },
    { key: "publisher", label: "Publisher" },
    { key: "is_collaborative", label: "Collaborative?" },
    { key: "collaborative_authors", label: "Collaborative Authors" },
  ],

  // =========================
  // BOOK REVIEW INTERNATIONAL
  // =========================
  book_review_international: [
    { key: "book_title", label: "Book Title" },
    { key: "review_year", label: "Review Year" },
    { key: "number_of_pages", label: "Number of Pages" },
    { key: "publisher", label: "Publisher" },
    { key: "country", label: "Country" },
  ],

  // =========================
  // BOOK REVIEW LOCAL
  // =========================
  book_review_local: [
    { key: "book_title", label: "Book Title" },
    { key: "review_year", label: "Review Year" },
    { key: "number_of_pages", label: "Number of Pages" },
    { key: "publisher", label: "Publisher" },
    { key: "country", label: "Country" },
  ],

  conference_proceeding: [
    { key: "conference_date", label: "Conference Date" },
    { key: "paper_title", label: "Paper Title" },
    { key: "conference_title", label: "Conference Title" },
    { key: "organizer_name", label: "Organizer" },
    { key: "proceedings_link", label: "Proceedings Link" },
    { key: "country", label: "Country" },
    { key: "scopus_indexed", label: "Scopus Indexed?" },
  ],

  trade_journal: [
    { key: "title", label: "Title" },
    { key: "journal_name", label: "Journal Name" },
    { key: "doi", label: "DOI/Publication Link" },
    { key: "publisher", label: "Publisher" },
    { key: "country", label: "Country" },
    { key: "total_authors", label: "Total Authors" },
    { key: "author_position", label: "Author Position" },
    { key: "publisher", label: "Publisher" },
    { key: "is_collaborative", label: "Collaborative?" },
    { key: "collaborative_authors", label: "Collaborative Authors" },
  ],

  industry_report: [
    { key: "title", label: "Title" },
    { key: "organization_name", label: "Organization Name" },
    { key: "industry_name", label: "Industry Name" },
    { key: "country", label: "Country" },
  ],

  text_book: [
    { key: "type", label: "Type" },
    { key: "total_authors", label: "Total Authors" },
    { key: "author_position", label: "Author Position" },
    { key: "is_collaborative", label: "Collaborative?" },
    { key: "collaborative_authors", label: "Collaborative Authors" },
    { key: "title", label: "Title" },
    { key: "publication", label: "Publisher" },
    { key: "discipline", label: "Discipline" },
    { key: "country", label: "Country" },
  ],

  case_publications: [
    { key: "title", label: "Title" },
    { key: "publisher", label: "Publisher" },
    {
      key: "used_for_classroom_teaching",
      label: "Used for Classroom Teaching?",
    },
    { key: "country", label: "Country" },
    { key: "type", label: "Journal Type" },
    { key: "total_authors", label: "Total Authors" },
    { key: "author_position", label: "Author Position" },
    { key: "is_collaborative", label: "Collaborative?" },
    { key: "collaborative_authors", label: "Collaborative Authors" },
  ],

  research_grant: [
    { key: "title", label: "Grant Title" },
    { key: "grant_number", label: "Grant Number" },
    { key: "grant_status", label: "Grant Status " },
    {
      key: "institution",
      label: "Awarding Body/Organization/Institution",
    },
    { key: "amount", label: "Grant Amount (BDT)" },
    { key: "country", label: "Country" },
  ],

  conference_session_chair: [
    { key: "presentations", label: "Presentation Title/Session Title" },
    { key: "conference_title", label: "Conference Title" },
    { key: "organizer_name", label: "Organizer's Name " },
    { key: "country", label: "Country" },
  ],

  new_program_development: [
    { key: "program_name", label: "Program Name" },
    { key: "role", label: "Role" },
    { key: "program_level", label: "Program Level" },
    { key: "institution", label: "Institution" },
    { key: "country", label: "Country" },
  ],

  international_academic_contribution: [
    { key: "starting_date", label: "From" },
    { key: "ending_date", label: "To" },
    { key: "nature", label: "Nature of the Affiliation" },
    { key: "institution_name", label: "Institution Name" },
    { key: "institution_accreditation", label: "Accreditation" },
    { key: "qs_ranking", label: "QS Ranking" },
    { key: "country", label: "Country" },
  ],
};

export default function AACSBdetails() {
  const { id } = useParams();

  const [data, setData] = useState({});
  const [loading, setLoading] = useState(true);
  const [expandedYears, setExpandedYears] = useState({});

  const [expandedEditorial, setExpandedEditorial] = useState(false);
  const [expandedSubcategories, setExpandedSubcategories] = useState({});

  // ============================================================
  // LOAD FACULTY DATA
  // ============================================================
  useEffect(() => {
    try {
      const savedAll = JSON.parse(
        localStorage.getItem("facultyData")
      );

      if (!savedAll) {
        throw new Error("No faculty data in localStorage");
      }

      const facultyData = savedAll || {};

      console.log("AACSB FACULTY DATA:", facultyData);
      console.log(
        "BOOK REVIEW INTERNATIONAL:",
        facultyData.book_review_international
      );
      console.log(
        "BOOK REVIEW LOCAL:",
        facultyData.book_review_local
      );

      setData(facultyData);
    } catch (err) {
      console.error(err);
      toast.error("Error reading faculty data");
      setData({});
    } finally {
      setLoading(false);
    }
  }, [id]);

  // ============================================================
  // TOGGLE YEAR
  // ============================================================
  const toggleYear = (sectionKey, year) => {
    const uniqueKey = `${sectionKey}-${year}`;

    setExpandedYears((prev) => ({
      ...prev,
      [uniqueKey]: !prev[uniqueKey],
    }));
  };

  // ============================================================
  // TOGGLE EDITORIAL
  // ============================================================
  const toggleEditorial = () => {
    setExpandedEditorial((prev) => !prev);
  };

  // ============================================================
  // TOGGLE SUBCATEGORY
  // ============================================================
  const toggleSubcategory = (key) => {
    setExpandedSubcategories((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  // ============================================================
  // GET RECORD DATE
  // ============================================================
  const getRecordDate = (r, sectionKey) => {
    // International academic contribution
    if (sectionKey === "international_academic_contribution") {
      if (r.starting_date) {
        return new Date(r.starting_date);
      }

      if (r.ending_date) {
        return new Date(r.ending_date);
      }
    }

    // Book reviews use review_year
    if (
      sectionKey === "book_review_international" ||
      sectionKey === "book_review_local"
    ) {
      if (
        r.review_year !== undefined &&
        r.review_year !== null &&
        r.review_year !== ""
      ) {
        const year = Number(r.review_year);

        if (!isNaN(year)) {
          return new Date(year, 0, 1);
        }
      }
    }

    if (r.date) {
      return new Date(r.date);
    }

    if (r.year) {
      // Handle numeric year safely
      if (
        typeof r.year === "number" ||
        /^\d{4}$/.test(String(r.year))
      ) {
        return new Date(Number(r.year), 0, 1);
      }

      return new Date(r.year.toString());
    }

    return null;
  };

  // ============================================================
  // FILTER BY AACSB DATE RANGE
  // ============================================================
  const filterByDateRange = (records, sectionKey) =>
    (records || []).filter((r) => {
      const d = getRecordDate(r, sectionKey);

      return (
        d &&
        !isNaN(d.getTime()) &&
        d >= START_DATE &&
        d <= END_DATE
      );
    });

  // ============================================================
  // GROUP BY YEAR
  // ============================================================
  const groupByYear = (records, sectionKey) => {
    const grouped = {};

    (records || []).forEach((r) => {
      let y;

      // Book Review International / Local
      if (
        sectionKey === "book_review_international" ||
        sectionKey === "book_review_local"
      ) {
        if (
          r.review_year !== undefined &&
          r.review_year !== null &&
          r.review_year !== ""
        ) {
          y = Number(r.review_year);
        } else {
          y = "Unknown";
        }
      }

      // International Academic Contribution
      else if (
        sectionKey === "international_academic_contribution" &&
        r.starting_date
      ) {
        y = new Date(r.starting_date).getFullYear();
      }

      // Normal year field
      else if (r.year) {
        if (
          typeof r.year === "number" ||
          /^\d{4}$/.test(String(r.year))
        ) {
          y = Number(r.year);
        } else {
          y = r.year.toString().split("-")[0];
        }
      }

      // Normal date field
      else if (r.date) {
        y = new Date(r.date).getFullYear();
      }

      y = y || "Unknown";

      if (!grouped[y]) {
        grouped[y] = [];
      }

      grouped[y].push(r);
    });

    return grouped;
  };

  // ============================================================
  // EDITORIAL SERVICES
  // ============================================================
  const processEditorialServices = () => {
    const raw = Array.isArray(data.editorial_service)
      ? data.editorial_service
      : [];

    const records = raw.filter((e) => {
      if (!e.year_from) return false;

      const d = new Date(e.year_from.toString());

      return d >= START_DATE && d <= END_DATE;
    });

    const result = {
      editor: [],
      special_issue: [],
      board: [],
      reviewer: [],
      conference: [],
      trade_editorial: [],
      trade_board: [],
      trade_reviewer: [],
      grant: [],
    };

    records.forEach((e) => {
      const role = (e.editorial_role || "").toLowerCase();
      const cat = (e.category || "").toLowerCase();

      if (
        ["editor in chief", "associate editor"].includes(role) &&
        cat !== "trade journal"
      ) {
        result.editor.push(e);
      }

      if (
        role === "special issue editor" &&
        cat !== "trade journal"
      ) {
        result.special_issue.push(e);
      }

      if (
        role === "editorial board member" &&
        cat !== "trade journal"
      ) {
        result.board.push(e);
      }

      if (
        role === "ad-hoc reviewer" &&
        cat !== "trade journal" &&
        cat !== "grant/grant proposal"
      ) {
        result.reviewer.push(e);
      }

      if (
        role === "ad-hoc reviewer" &&
        cat === "conference"
      ) {
        result.conference.push(e);
      }

      if (
        ["editor in chief", "associate editor"].includes(role) &&
        cat === "trade journal"
      ) {
        result.trade_editorial.push(e);
      }

      if (
        role === "editorial board member" &&
        cat === "trade journal"
      ) {
        result.trade_board.push(e);
      }

      if (
        role === "ad-hoc reviewer" &&
        cat === "trade journal"
      ) {
        result.trade_reviewer.push(e);
      }

      if (cat === "grant/grant proposal") {
        result.grant.push(e);
      }
    });

    console.log("EDITORIAL RAW:", raw);
    console.log("EDITORIAL FILTERED:", records);

    return result;
  };

  // ============================================================
  // GENERIC SECTION RENDERER
  // ============================================================
  const renderSection = (title, key) => {
    const schema = SECTION_COLUMN_SCHEMA[key];

    let records = Array.isArray(data[key])
      ? data[key]
      : [];

    records = filterByDateRange(records, key);

    const totalCount = records.length;

    if (!records.length) {
      return (
        <div style={{ marginTop: 20 }} key={key}>
          <h3
            style={{
              background: "#1d4786",
              color: "#fff",
              padding: 8,
            }}
          >
            {title} (Total: {totalCount})
          </h3>

          <p style={{ padding: 8 }}>
            No records available
          </p>
        </div>
      );
    }

    const groupedByYear = groupByYear(records, key);

    return (
      <div style={{ marginTop: 20 }} key={key}>
        <h3
          style={{
            background: "#1d4786",
            color: "#fff",
            padding: 8,
          }}
        >
          {title} (Total: {totalCount})
        </h3>

        {Object.entries(groupedByYear)
          .sort(([a], [b]) =>
            Number(a) - Number(b)
          )
          .map(([year, yearRecords]) => {
            const uniqueKey = `${key}-${year}`;
            const isOpen = expandedYears[uniqueKey];

            return (
              <div
                key={year}
                style={{ marginBottom: 20 }}
              >
                <h4
                  onClick={() =>
                    toggleYear(key, year)
                  }
                  style={{
                    cursor: "pointer",
                    background: "#eee",
                    padding: "10px",
                    borderRadius: "5px",
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                >
                  <span>
                    {year} ({yearRecords.length})
                  </span>

                  <span>
                    {isOpen ? "▲" : "▼"}
                  </span>
                </h4>

                {isOpen && (
                  <div style={{ overflowX: "auto" }}>
                    <table
                      style={{
                        width: "100%",
                        borderCollapse: "collapse",
                        marginTop: "10px",
                      }}
                    >
                      <thead>
                        <tr
                          style={{
                            background: "#1d4786",
                            color: "#fff",
                          }}
                        >
                          {schema.map((c, index) => (
                            <th
                              key={`${c.key}-${index}`}
                              style={{
                                padding: "10px",
                                border: "1px solid #ccc",
                                textAlign: "left",
                              }}
                            >
                              {c.label}
                            </th>
                          ))}
                        </tr>
                      </thead>

                      <tbody>
                        {yearRecords.map((r, idx) => (
                          <tr
                            key={idx}
                            style={{
                              borderBottom:
                                "2px solid #ccc",
                              background:
                                idx % 2 === 0
                                  ? "#fafafa"
                                  : "#ffffff",
                            }}
                          >
                            {schema.map((c, index) => (
                              <td
                                key={`${c.key}-${index}`}
                                style={{
                                  padding: "14px",
                                  border:
                                    "1px solid #eee",
                                }}
                              >
                                {r[c.key] ?? "-"}
                              </td>
                            ))}
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            );
          })}
      </div>
    );
  };

  // ============================================================
  // EDITORIAL SECTION RENDER
  // ============================================================
  const renderEditorialSection = () => {
    const sections = processEditorialServices();

    const totalCount = Object.values(sections).reduce(
      (sum, arr) => sum + arr.length,
      0
    );

    const parseYear = (r) => {
      if (r.year_from) {
        return r.year_from.toString().split("-")[0];
      }

      if (r.year) {
        return r.year.toString().split("-")[0];
      }

      return "Unknown";
    };

    return (
      <div style={{ marginTop: 20 }}>
        <h3
          onClick={toggleEditorial}
          style={{
            background: "#1d4786",
            color: "#fff",
            padding: 8,
            cursor: "pointer",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <span>
            Editorial & Review Services (Total: {totalCount})
          </span>

          <span>
            {expandedEditorial ? "▲" : "▼"}
          </span>
        </h3>

        {expandedEditorial &&
          Object.entries(sections).map(
            ([key, records]) => {
              const subKey = `editorial-sub-${key}`;
              const isSubOpen =
                expandedSubcategories[subKey];

              const groupedByYear = {};

              records.forEach((r) => {
                const y = parseYear(r);

                if (!groupedByYear[y]) {
                  groupedByYear[y] = [];
                }

                groupedByYear[y].push(r);
              });

              return (
                <div
                  key={key}
                  style={{ marginTop: 15 }}
                >
                  <h4
                    onClick={() =>
                      toggleSubcategory(subKey)
                    }
                    style={{
                      background: "#eee",
                      padding: "8px",
                      cursor: "pointer",
                      display: "flex",
                      justifyContent:
                        "space-between",
                      borderRadius: "5px",
                    }}
                  >
                    <span>
                      {key
                        .replace(/_/g, " ")
                        .toUpperCase()}{" "}
                      ({records.length})
                    </span>

                    <span>
                      {isSubOpen ? "▲" : "▼"}
                    </span>
                  </h4>

                  {!records.length ? (
                    <p style={{ padding: 8 }}>
                      No records
                    </p>
                  ) : (
                    isSubOpen &&
                    Object.entries(groupedByYear)
                      .sort(([a], [b]) =>
                        a.localeCompare(b)
                      )
                      .map(
                        ([
                          year,
                          yearRecords,
                        ]) => {
                          const uniqueKey = `editorial-${key}-${year}`;
                          const isOpen =
                            expandedYears[
                              uniqueKey
                            ];

                          return (
                            <div
                              key={year}
                              style={{
                                marginBottom: 20,
                              }}
                            >
                              <h5
                                onClick={() =>
                                  toggleYear(
                                    `editorial-${key}`,
                                    year
                                  )
                                }
                                style={{
                                  cursor:
                                    "pointer",
                                  background:
                                    "#ddd",
                                  padding:
                                    "8px",
                                  borderRadius:
                                    "5px",
                                  display:
                                    "flex",
                                  justifyContent:
                                    "space-between",
                                }}
                              >
                                <span>
                                  {year} (
                                  {
                                    yearRecords.length
                                  }
                                  )
                                </span>

                                <span>
                                  {isOpen
                                    ? "▲"
                                    : "▼"}
                                </span>
                              </h5>

                              {isOpen && (
                                <div
                                  style={{
                                    overflowX:
                                      "auto",
                                  }}
                                >
                                  <table
                                    style={{
                                      width:
                                        "100%",
                                      borderCollapse:
                                        "collapse",
                                      marginTop:
                                        "10px",
                                    }}
                                  >
                                    <thead>
                                      <tr
                                        style={{
                                          background:
                                            "#1d4786",
                                          color:
                                            "#fff",
                                        }}
                                      >
                                        <th
                                          style={{
                                            padding:
                                              "10px",
                                            border:
                                              "1px solid #ccc",
                                          }}
                                        >
                                          Journal /
                                          Conference
                                        </th>

                                        <th
                                          style={{
                                            padding:
                                              "10px",
                                            border:
                                              "1px solid #ccc",
                                          }}
                                        >
                                          Role
                                        </th>

                                        <th
                                          style={{
                                            padding:
                                              "10px",
                                            border:
                                              "1px solid #ccc",
                                          }}
                                        >
                                          Category
                                        </th>

                                        <th
                                          style={{
                                            padding:
                                              "10px",
                                            border:
                                              "1px solid #ccc",
                                          }}
                                        >
                                          Year
                                        </th>
                                      </tr>
                                    </thead>

                                    <tbody>
                                      {yearRecords.map(
                                        (r, i) => (
                                          <tr key={i}>
                                            <td
                                              style={{
                                                padding:
                                                  "10px",
                                                border:
                                                  "1px solid #eee",
                                              }}
                                            >
                                              {r.journal_name ||
                                                r.conference_title ||
                                                "-"}
                                            </td>

                                            <td
                                              style={{
                                                padding:
                                                  "10px",
                                                border:
                                                  "1px solid #eee",
                                              }}
                                            >
                                              {r.editorial_role ||
                                                "-"}
                                            </td>

                                            <td
                                              style={{
                                                padding:
                                                  "10px",
                                                border:
                                                  "1px solid #eee",
                                              }}
                                            >
                                              {r.category ||
                                                "-"}
                                            </td>

                                            <td
                                              style={{
                                                padding:
                                                  "10px",
                                                border:
                                                  "1px solid #eee",
                                              }}
                                            >
                                              {r.year_from ||
                                                r.year ||
                                                "-"}
                                            </td>
                                          </tr>
                                        )
                                      )}
                                    </tbody>
                                  </table>
                                </div>
                              )}
                            </div>
                          );
                        }
                      )
                  )}
                </div>
              );
            }
          )}
      </div>
    );
  };

  // ============================================================
  // RESEARCH SUPERVISION
  // ============================================================
  const [expandedSupervision, setExpandedSupervision] =
    useState(false);

  const toggleSupervision = () => {
    setExpandedSupervision((prev) => !prev);
  };

  const processResearchSupervision = () => {
    const raw = Array.isArray(
      data.research_supervision
    )
      ? data.research_supervision
      : [];

    const records = raw.filter((r) => {
      const d = r.start_year
        ? new Date(r.start_year)
        : null;

      return (
        d &&
        d >= START_DATE &&
        d <= END_DATE
      );
    });

    const result = {
      phd_chair: [],
      phd_member: [],
      masters_chair: [],
      masters_member: [],
    };

    records.forEach((r) => {
      const role = (
        r.research_role || ""
      ).toLowerCase();

      const deg = (
        r.degree || ""
      ).toLowerCase();

      const isChair =
        role.includes("chair") ||
        role.includes("main");

      if (deg === "phd") {
        isChair
          ? result.phd_chair.push(r)
          : result.phd_member.push(r);
      }

      if (
        ["masters", "mphil"].includes(deg)
      ) {
        isChair
          ? result.masters_chair.push(r)
          : result.masters_member.push(r);
      }
    });

    return result;
  };

  const renderResearchSupervision = () => {
    const sections =
      processResearchSupervision();

    const totalCount =
      Object.values(sections).reduce(
        (sum, arr) => sum + arr.length,
        0
      );

    const parseYear = (r) => {
      if (r.start_year) {
        return new Date(
          r.start_year
        ).getFullYear();
      }

      if (r.end_year) {
        return new Date(
          r.end_year
        ).getFullYear();
      }

      return "Unknown";
    };

    return (
      <div style={{ marginTop: 20 }}>
        <h3
          onClick={toggleSupervision}
          style={{
            background: "#1d4786",
            color: "#fff",
            padding: 8,
            cursor: "pointer",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <span>
            Research Supervision (Total:{" "}
            {totalCount})
          </span>

          <span>
            {expandedSupervision
              ? "▲"
              : "▼"}
          </span>
        </h3>

        {expandedSupervision &&
          Object.entries(sections).map(
            ([key, records]) => {
              const subKey = `supervision-sub-${key}`;
              const isSubOpen =
                expandedSubcategories[
                  subKey
                ];

              const groupedByYear = {};

              records.forEach((r) => {
                const y = parseYear(r);

                if (!groupedByYear[y]) {
                  groupedByYear[y] = [];
                }

                groupedByYear[y].push(r);
              });

              return (
                <div
                  key={key}
                  style={{
                    marginTop: 15,
                  }}
                >
                  <h4
                    onClick={() =>
                      toggleSubcategory(
                        subKey
                      )
                    }
                    style={{
                      background: "#eee",
                      padding: "8px",
                      cursor: "pointer",
                      display: "flex",
                      justifyContent:
                        "space-between",
                      borderRadius: "5px",
                    }}
                  >
                    <span>
                      {key
                        .replace(/_/g, " ")
                        .toUpperCase()}{" "}
                      ({records.length})
                    </span>

                    <span>
                      {isSubOpen
                        ? "▲"
                        : "▼"}
                    </span>
                  </h4>

                  {!records.length ? (
                    <p style={{ padding: 8 }}>
                      No records
                    </p>
                  ) : (
                    isSubOpen &&
                    Object.entries(
                      groupedByYear
                    )
                      .sort(([a], [b]) =>
                        a.localeCompare(b)
                      )
                      .map(
                        ([
                          year,
                          yearRecords,
                        ]) => {
                          const uniqueKey = `supervision-${key}-${year}`;
                          const isOpen =
                            expandedYears[
                              uniqueKey
                            ];

                          return (
                            <div
                              key={year}
                              style={{
                                marginBottom:
                                  20,
                              }}
                            >
                              <h5
                                onClick={() =>
                                  toggleYear(
                                    `supervision-${key}`,
                                    year
                                  )
                                }
                                style={{
                                  cursor:
                                    "pointer",
                                  background:
                                    "#ddd",
                                  padding:
                                    "8px",
                                  borderRadius:
                                    "5px",
                                  display:
                                    "flex",
                                  justifyContent:
                                    "space-between",
                                }}
                              >
                                <span>
                                  {year} (
                                  {
                                    yearRecords.length
                                  }
                                  )
                                </span>

                                <span>
                                  {isOpen
                                    ? "▲"
                                    : "▼"}
                                </span>
                              </h5>

                              {isOpen && (
                                <div
                                  style={{
                                    overflowX:
                                      "auto",
                                  }}
                                >
                                  <table
                                    style={{
                                      width:
                                        "100%",
                                      borderCollapse:
                                        "collapse",
                                      marginTop:
                                        "10px",
                                    }}
                                  >
                                    <thead>
                                      <tr
                                        style={{
                                          background:
                                            "#1d4786",
                                          color:
                                            "#fff",
                                        }}
                                      >
                                        <th
                                          style={{
                                            padding:
                                              10,
                                          }}
                                        >
                                          Thesis
                                          Title
                                        </th>

                                        <th
                                          style={{
                                            padding:
                                              10,
                                          }}
                                        >
                                          Degree
                                        </th>

                                        <th
                                          style={{
                                            padding:
                                              10,
                                          }}
                                        >
                                          Role
                                        </th>

                                        <th
                                          style={{
                                            padding:
                                              10,
                                          }}
                                        >
                                          Institution
                                        </th>

                                        <th
                                          style={{
                                            padding:
                                              10,
                                          }}
                                        >
                                          Country
                                        </th>

                                        <th
                                          style={{
                                            padding:
                                              10,
                                          }}
                                        >
                                          Start
                                          Year
                                        </th>
                                      </tr>
                                    </thead>

                                    <tbody>
                                      {yearRecords.map(
                                        (r, i) => (
                                          <tr key={i}>
                                            <td
                                              style={{
                                                padding:
                                                  10,
                                              }}
                                            >
                                              {r.thesis_title ||
                                                "-"}
                                            </td>

                                            <td
                                              style={{
                                                padding:
                                                  10,
                                              }}
                                            >
                                              {r.degree ||
                                                "-"}
                                            </td>

                                            <td
                                              style={{
                                                padding:
                                                  10,
                                              }}
                                            >
                                              {r.research_role ||
                                                "-"}
                                            </td>

                                            <td
                                              style={{
                                                padding:
                                                  10,
                                              }}
                                            >
                                              {r.institution ||
                                                "-"}
                                            </td>

                                            <td
                                              style={{
                                                padding:
                                                  10,
                                              }}
                                            >
                                              {r.country ||
                                                "-"}
                                            </td>

                                            <td
                                              style={{
                                                padding:
                                                  10,
                                              }}
                                            >
                                              {r.start_year
                                                ? new Date(
                                                    r.start_year
                                                  ).getFullYear()
                                                : "-"}
                                            </td>
                                          </tr>
                                        )
                                      )}
                                    </tbody>
                                  </table>
                                </div>
                              )}
                            </div>
                          );
                        }
                      )
                  )}
                </div>
              );
            }
          )}
      </div>
    );
  };

  // ============================================================
  // PROPOSAL NOT RECEIVED
  // ============================================================
  const processProposalNotReceived = () => {
    const yearwise = {};

    (data.research_grant || []).forEach(
      (g) => {
        if (
          (g.grant_status || "").toLowerCase() !==
          "not received"
        ) {
          return;
        }

        const year = g.year
          ? new Date(g.year).getFullYear()
          : null;

        if (!year) return;

        if (
          year <
            START_DATE.getFullYear() ||
          year >
            END_DATE.getFullYear()
        ) {
          return;
        }

        const amount =
          Number(
            g.amount?.replace(
              /[^0-9.-]+/g,
              ""
            )
          ) || 0;

        const type =
          g.institution?.toLowerCase() ===
            "brac university" &&
          amount >= 500000
            ? "internal"
            : g.institution?.toLowerCase() !==
                  "brac university" &&
                amount >= 1000000
              ? "external"
              : null;

        if (!type) return;

        if (!yearwise[year]) {
          yearwise[year] = {
            internal: [],
            external: [],
          };
        }

        yearwise[year][type].push({
          title: g.title,
          institution:
            g.institution,
          amount: g.amount,
        });
      }
    );

    return yearwise;
  };

  const renderProposalNotReceived = () => {
    const yearwise =
      processProposalNotReceived();

    const years = Object.keys(
      yearwise
    ).sort((a, b) => b - a);

    return (
      <div style={{ marginTop: 20 }}>
        <h3
          style={{
            background: "#1d4786",
            color: "#fff",
            padding: 8,
          }}
        >
          Proposal Writing (Not Received)
        </h3>

        {years.length === 0 ? (
          <p style={{ padding: 8 }}>
            No proposals in "not received"
            status
          </p>
        ) : (
          years.map((year) => {
            const uniqueKey = `proposal-${year}`;
            const isOpen =
              expandedYears[uniqueKey];

            const dataByYear =
              yearwise[year];

            const total =
              dataByYear.internal.length +
              dataByYear.external.length;

            return (
              <div
                key={year}
                style={{ marginTop: 10 }}
              >
                <h4
                  style={{
                    background: "#ccc",
                    padding: 8,
                    cursor: "pointer",
                  }}
                  onClick={() =>
                    toggleYear(
                      "proposal",
                      year
                    )
                  }
                >
                  {year} (Total: {total}){" "}
                  {isOpen ? "▲" : "▼"}
                </h4>

                {isOpen && (
                  <div
                    style={{
                      overflowX: "auto",
                    }}
                  >
                    <table
                      style={{
                        width: "100%",
                        borderCollapse:
                          "collapse",
                        marginTop: 5,
                      }}
                    >
                      <thead>
                        <tr
                          style={{
                            background:
                              "#1d4786",
                            color: "#fff",
                          }}
                        >
                          <th
                            style={{
                              padding: 10,
                              border:
                                "1px solid #ccc",
                            }}
                          >
                            Type
                          </th>

                          <th
                            style={{
                              padding: 10,
                              border:
                                "1px solid #ccc",
                            }}
                          >
                            Title
                          </th>

                          <th
                            style={{
                              padding: 10,
                              border:
                                "1px solid #ccc",
                            }}
                          >
                            Institution
                          </th>

                          <th
                            style={{
                              padding: 10,
                              border:
                                "1px solid #ccc",
                            }}
                          >
                            Amount
                          </th>
                        </tr>
                      </thead>

                      <tbody>
                        {["internal", "external"].map(
                          (type) =>
                            dataByYear[
                              type
                            ].map(
                              (
                                item,
                                idx
                              ) => (
                                <tr
                                  key={
                                    type +
                                    idx
                                  }
                                >
                                  <td
                                    style={{
                                      padding: 10,
                                      border:
                                        "1px solid #eee",
                                    }}
                                  >
                                    {type ===
                                    "internal"
                                      ? "Internal (BRAC University)"
                                      : "External (Other Institutions)"}
                                  </td>

                                  <td
                                    style={{
                                      padding: 10,
                                      border:
                                        "1px solid #eee",
                                    }}
                                  >
                                    {item.title}
                                  </td>

                                  <td
                                    style={{
                                      padding: 10,
                                      border:
                                        "1px solid #eee",
                                    }}
                                  >
                                    {item.institution}
                                  </td>

                                  <td
                                    style={{
                                      padding: 10,
                                      border:
                                        "1px solid #eee",
                                    }}
                                  >
                                    {item.amount}
                                  </td>
                                </tr>
                              )
                            )
                        )}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            );
          })
        )}
      </div>
    );
  };

  // ============================================================
  // CONFERENCE ORGANIZATION
  // ============================================================
  const processConferenceOrganization = () => {
    const events =
      data.academic_event_organized || [];

    const filtered = events.filter((e) => {
      if (!e.year) return false;

      const y = new Date(
        e.year
      ).getFullYear();

      return (
        y >= START_DATE.getFullYear() &&
        y <= END_DATE.getFullYear() &&
        e.event_type === "Conference"
      );
    });

    const roles = {
      chair: [],
      cochair: [],
      member: [],
    };

    filtered.forEach((e) => {
      switch (e.role) {
        case "Chair":
          roles.chair.push(e);
          break;

        case "Co-Chair":
          roles.cochair.push(e);
          break;

        case "Committee Member":
          roles.member.push(e);
          break;

        default:
          break;
      }
    });

    return roles;
  };

  const renderConferenceOrganization =
    () => {
      const roles =
        processConferenceOrganization();

      const totalCount =
        Object.values(roles).reduce(
          (sum, arr) =>
            sum + arr.length,
          0
        );

      return (
        <div style={{ marginTop: 20 }}>
          <h3
            style={{
              background: "#1d4786",
              color: "#fff",
              padding: 8,
            }}
          >
            Conference Organization (Total:{" "}
            {totalCount})
          </h3>

          {totalCount === 0 ? (
            <p style={{ padding: 8 }}>
              No conference organization
              records
            </p>
          ) : (
            Object.entries(roles).map(
              ([roleKey, records]) => {
                const subKey = `conference-org-${roleKey}`;

                const isSubOpen =
                  expandedSubcategories[
                    subKey
                  ];

                const groupedByYear = {};

                records.forEach((r) => {
                  const y = r.year
                    ? new Date(
                        r.year
                      ).getFullYear()
                    : "Unknown";

                  if (
                    !groupedByYear[y]
                  ) {
                    groupedByYear[y] = [];
                  }

                  groupedByYear[y].push(
                    r
                  );
                });

                return (
                  <div
                    key={roleKey}
                    style={{
                      marginTop: 10,
                    }}
                  >
                    <h4
                      onClick={() =>
                        toggleSubcategory(
                          subKey
                        )
                      }
                      style={{
                        background: "#eee",
                        padding: 8,
                        cursor:
                          "pointer",
                        display: "flex",
                        justifyContent:
                          "space-between",
                        borderRadius:
                          "5px",
                      }}
                    >
                      <span>
                        {roleKey
                          .charAt(0)
                          .toUpperCase() +
                          roleKey.slice(
                            1
                          )}{" "}
                        ({records.length})
                      </span>

                      <span>
                        {isSubOpen
                          ? "▲"
                          : "▼"}
                      </span>
                    </h4>

                    {isSubOpen &&
                      Object.entries(
                        groupedByYear
                      )
                        .sort(
                          ([a], [b]) =>
                            b - a
                        )
                        .map(
                          ([
                            year,
                            yearRecords,
                          ]) => {
                            const uniqueKey = `conference-${roleKey}-${year}`;

                            const isOpen =
                              expandedYears[
                                uniqueKey
                              ];

                            return (
                              <div
                                key={year}
                                style={{
                                  marginBottom:
                                    15,
                                }}
                              >
                                <h5
                                  onClick={() =>
                                    toggleYear(
                                      `conference-${roleKey}`,
                                      year
                                    )
                                  }
                                  style={{
                                    background:
                                      "#ddd",
                                    padding:
                                      8,
                                    cursor:
                                      "pointer",
                                    display:
                                      "flex",
                                    justifyContent:
                                      "space-between",
                                    borderRadius:
                                      "5px",
                                  }}
                                >
                                  <span>
                                    {year} (
                                    {
                                      yearRecords.length
                                    }
                                    )
                                  </span>

                                  <span>
                                    {isOpen
                                      ? "▲"
                                      : "▼"}
                                  </span>
                                </h5>

                                {isOpen && (
                                  <div
                                    style={{
                                      overflowX:
                                        "auto",
                                    }}
                                  >
                                    <table
                                      style={{
                                        width:
                                          "100%",
                                        borderCollapse:
                                          "collapse",
                                        marginTop:
                                          5,
                                      }}
                                    >
                                      <thead>
                                        <tr
                                          style={{
                                            background:
                                              "#1d4786",
                                            color:
                                              "#fff",
                                          }}
                                        >
                                          <th
                                            style={{
                                              padding:
                                                10,
                                              border:
                                                "1px solid #ccc",
                                            }}
                                          >
                                            Conference
                                            Name
                                          </th>

                                          <th
                                            style={{
                                              padding:
                                                10,
                                              border:
                                                "1px solid #ccc",
                                            }}
                                          >
                                            Role
                                          </th>

                                          <th
                                            style={{
                                              padding:
                                                10,
                                              border:
                                                "1px solid #ccc",
                                            }}
                                          >
                                            Year
                                          </th>

                                          <th
                                            style={{
                                              padding:
                                                10,
                                              border:
                                                "1px solid #ccc",
                                            }}
                                          >
                                            Institution
                                          </th>

                                          <th
                                            style={{
                                              padding:
                                                10,
                                              border:
                                                "1px solid #ccc",
                                            }}
                                          >
                                            Country
                                          </th>
                                        </tr>
                                      </thead>

                                      <tbody>
                                        {yearRecords.map(
                                          (
                                            r,
                                            idx
                                          ) => (
                                            <tr
                                              key={
                                                idx
                                              }
                                              style={{
                                                background:
                                                  idx %
                                                    2 ===
                                                  0
                                                    ? "#fafafa"
                                                    : "#ffffff",
                                              }}
                                            >
                                              <td
                                                style={{
                                                  padding:
                                                    10,
                                                  border:
                                                    "1px solid #eee",
                                                }}
                                              >
                                                {r.event_name ||
                                                  "-"}
                                              </td>

                                              <td
                                                style={{
                                                  padding:
                                                    10,
                                                  border:
                                                    "1px solid #eee",
                                                }}
                                              >
                                                {r.role ||
                                                  "-"}
                                              </td>

                                              <td
                                                style={{
                                                  padding:
                                                    10,
                                                  border:
                                                    "1px solid #eee",
                                                }}
                                              >
                                                {r.year
                                                  ? new Date(
                                                      r.year
                                                    ).getFullYear()
                                                  : "-"}
                                              </td>

                                              <td
                                                style={{
                                                  padding:
                                                    10,
                                                  border:
                                                    "1px solid #eee",
                                                }}
                                              >
                                                {r.institution ||
                                                  "-"}
                                              </td>

                                              <td
                                                style={{
                                                  padding:
                                                    10,
                                                  border:
                                                    "1px solid #eee",
                                                }}
                                              >
                                                {r.country ||
                                                  "-"}
                                              </td>
                                            </tr>
                                          )
                                        )}
                                      </tbody>
                                    </table>
                                  </div>
                                )}
                              </div>
                            );
                          }
                        )}
                  </div>
                );
              }
            )
          )}
        </div>
      );
    };

  // ============================================================
  // NEW DEGREE COURSE DEVELOPMENT
  // ============================================================
  const renderNewDegreeCourseDevelopment =
    () => {
      const key =
        "new_degree_course_development";

      const title =
        "New Degree Course Development (28)";

      const rows = Array.isArray(
        data[key]
      )
        ? data[key]
        : [];

      const categories = {
        lead_new: [],
        lead_revision: [],
        member_new: [],
        member_revision: [],
      };

      rows.forEach((c) => {
        if (!c.year) return;

        const d = new Date(c.year);

        if (
          isNaN(d.getTime()) ||
          d < START_DATE ||
          d > END_DATE
        ) {
          return;
        }

        const role = (
          c.role || ""
        )
          .trim()
          .toLowerCase();

        const nature = (
          c.nature || ""
        )
          .trim()
          .toLowerCase();

        if (
          role === "lead" &&
          nature === "newly developed"
        ) {
          categories.lead_new.push(c);
        } else if (
          role === "lead" &&
          nature === "revision"
        ) {
          categories.lead_revision.push(
            c
          );
        } else if (
          role === "member" &&
          nature === "newly developed"
        ) {
          categories.member_new.push(c);
        } else if (
          role === "member" &&
          nature === "revision"
        ) {
          categories.member_revision.push(
            c
          );
        }
      });

      const totalCount =
        Object.values(categories).reduce(
          (sum, arr) =>
            sum + arr.length,
          0
        );

      const parseYear = (r) =>
        r.year
          ? new Date(
              r.year
            ).getFullYear()
          : "Unknown";

      return (
        <div style={{ marginTop: 20 }}>
          <h3
            style={{
              background: "#1d4786",
              color: "#fff",
              padding: 8,
            }}
          >
            {title} (Total:{" "}
            {totalCount})
          </h3>

          {Object.entries(categories).map(
            ([catKey, records]) => {
              const subKey = `course-dev-${catKey}`;

              const isSubOpen =
                expandedSubcategories[
                  subKey
                ];

              const groupedByYear = {};

              records.forEach((r) => {
                const y = parseYear(r);

                if (
                  !groupedByYear[y]
                ) {
                  groupedByYear[y] = [];
                }

                groupedByYear[y].push(
                  r
                );
              });

              return (
                <div
                  key={catKey}
                  style={{
                    marginTop: 15,
                  }}
                >
                  <h4
                    onClick={() =>
                      toggleSubcategory(
                        subKey
                      )
                    }
                    style={{
                      background: "#eee",
                      padding: "8px",
                      cursor:
                        "pointer",
                      display:
                        "flex",
                      justifyContent:
                        "space-between",
                      borderRadius:
                        "5px",
                    }}
                  >
                    <span>
                      {catKey
                        .replace(
                          /_/g,
                          " "
                        )
                        .toUpperCase()}{" "}
                      ({records.length})
                    </span>

                    <span>
                      {isSubOpen
                        ? "▲"
                        : "▼"}
                    </span>
                  </h4>

                  {!records.length ? (
                    <p
                      style={{
                        padding: 8,
                      }}
                    >
                      No records
                    </p>
                  ) : (
                    isSubOpen &&
                    Object.entries(
                      groupedByYear
                    )
                      .sort(
                        ([a], [b]) =>
                          b - a
                      )
                      .map(
                        ([
                          year,
                          yearRecords,
                        ]) => {
                          const uniqueKey = `course-dev-${catKey}-${year}`;

                          const isOpen =
                            expandedYears[
                              uniqueKey
                            ];

                          return (
                            <div
                              key={year}
                              style={{
                                marginBottom:
                                  15,
                              }}
                            >
                              <h5
                                onClick={() =>
                                  toggleYear(
                                    `course-dev-${catKey}`,
                                    year
                                  )
                                }
                                style={{
                                  cursor:
                                    "pointer",
                                  background:
                                    "#ddd",
                                  padding:
                                    "8px",
                                  borderRadius:
                                    "5px",
                                  display:
                                    "flex",
                                  justifyContent:
                                    "space-between",
                                }}
                              >
                                <span>
                                  {year} (
                                  {
                                    yearRecords.length
                                  }
                                  )
                                </span>

                                <span>
                                  {isOpen
                                    ? "▲"
                                    : "▼"}
                                </span>
                              </h5>

                              {isOpen && (
                                <div
                                  style={{
                                    overflowX:
                                      "auto",
                                  }}
                                >
                                  <table
                                    style={{
                                      width:
                                        "100%",
                                      borderCollapse:
                                        "collapse",
                                      marginTop:
                                        "10px",
                                    }}
                                  >
                                    <thead>
                                      <tr
                                        style={{
                                          background:
                                            "#1d4786",
                                          color:
                                            "#fff",
                                        }}
                                      >
                                        <th
                                          style={{
                                            padding:
                                              10,
                                            border:
                                              "1px solid #ccc",
                                          }}
                                        >
                                          Course
                                          Name
                                        </th>

                                        <th
                                          style={{
                                            padding:
                                              10,
                                            border:
                                              "1px solid #ccc",
                                          }}
                                        >
                                          Role
                                        </th>

                                        <th
                                          style={{
                                            padding:
                                              10,
                                            border:
                                              "1px solid #ccc",
                                          }}
                                        >
                                          Nature
                                        </th>

                                        <th
                                          style={{
                                            padding:
                                              10,
                                            border:
                                              "1px solid #ccc",
                                          }}
                                        >
                                          Course
                                          Level
                                        </th>

                                        <th
                                          style={{
                                            padding:
                                              10,
                                            border:
                                              "1px solid #ccc",
                                          }}
                                        >
                                          Institution
                                        </th>

                                        <th
                                          style={{
                                            padding:
                                              10,
                                            border:
                                              "1px solid #ccc",
                                          }}
                                        >
                                          Country
                                        </th>
                                      </tr>
                                    </thead>

                                    <tbody>
                                      {yearRecords.map(
                                        (
                                          r,
                                          idx
                                        ) => (
                                          <tr
                                            key={
                                              idx
                                            }
                                            style={{
                                              background:
                                                idx %
                                                  2 ===
                                                0
                                                  ? "#fafafa"
                                                  : "#ffffff",
                                            }}
                                          >
                                            <td
                                              style={{
                                                padding:
                                                  10,
                                                border:
                                                  "1px solid #eee",
                                              }}
                                            >
                                              {r.course_name ||
                                                "-"}
                                            </td>

                                            <td
                                              style={{
                                                padding:
                                                  10,
                                                border:
                                                  "1px solid #eee",
                                              }}
                                            >
                                              {r.role ||
                                                "-"}
                                            </td>

                                            <td
                                              style={{
                                                padding:
                                                  10,
                                                border:
                                                  "1px solid #eee",
                                              }}
                                            >
                                              {r.nature ||
                                                "-"}
                                            </td>

                                            <td
                                              style={{
                                                padding:
                                                  10,
                                                border:
                                                  "1px solid #eee",
                                              }}
                                            >
                                              {r.course_level ||
                                                "-"}
                                            </td>

                                            <td
                                              style={{
                                                padding:
                                                  10,
                                                border:
                                                  "1px solid #eee",
                                              }}
                                            >
                                              {r.institution ||
                                                "-"}
                                            </td>

                                            <td
                                              style={{
                                                padding:
                                                  10,
                                                border:
                                                  "1px solid #eee",
                                              }}
                                            >
                                              {r.country ||
                                                "-"}
                                            </td>
                                          </tr>
                                        )
                                      )}
                                    </tbody>
                                  </table>
                                </div>
                              )}
                            </div>
                          );
                        }
                      )
                  )}
                </div>
              );
            }
          )}
        </div>
      );
    };

  // ============================================================
  // LOADING / EMPTY
  // ============================================================
  if (loading) {
    return <p>Loading...</p>;
  }

  if (
    !data ||
    Object.keys(data).length === 0
  ) {
    return (
      <p>
        No data available for this
        faculty
      </p>
    );
  }

  // ============================================================
  // PAGE
  // ============================================================
  return (
    <div
      style={{
        padding: 20,
        backgroundImage: `url(${img})`,
        minHeight: "100vh",
        backgroundSize: "cover",
      }}
    >
      <ToastContainer />

      {/* Back button */}
      <button
        onClick={() =>
          window.history.back()
        }
        style={{
          padding: "8px 16px",
          marginBottom: 20,
          fontSize: "1rem",
          backgroundColor: "#1d4786",
          color: "#fff",
          border: "none",
          borderRadius: "5px",
          cursor: "pointer",
        }}
      >
        ← Back to AACSB Dashboard
      </button>

      <h2>
        AACSB Records (2020–2026,
        Year-wise)
      </h2>

      {renderSection(
        "Scholarly Publications",
        "academic_journal_articles"
      )}

      {renderSection(
        "Scholarly Books Published",
        "book"
      )}

      {renderSection(
        "Edited Book Chapters Published (3A–3B)",
        "book_chapters"
      )}

      {/* ======================================================
          BOOK REVIEW INTERNATIONAL
          ====================================================== */}
      {renderSection(
        "Book Review International",
        "book_review_international"
      )}

      {/* ======================================================
          BOOK REVIEW LOCAL
          ====================================================== */}
      {renderSection(
        "Book Review Local",
        "book_review_local"
      )}

      {renderSection(
        "Published Conference Proceedings & Research Papers Presented",
        "conference_proceeding"
      )}

      {renderSection(
        "Renowned Non-Academic/Trade Journals",
        "trade_journal"
      )}

      {renderSection(
        " Industry Reports & Press Articles (Op-Eds/Editorials)",
        "industry_report"
      )}

      {renderSection(
        "Textbooks (relevant to the field of teaching)",
        "text_book"
      )}

      {renderSection(
        "Case Publications",
        "case_publications"
      )}

      {renderSection(
        "Research Grants",
        "research_grant"
      )}

      {renderEditorialSection()}

      {renderResearchSupervision()}

      {renderProposalNotReceived()}

      {renderConferenceOrganization()}

      {renderSection(
        "Keynote Speeches / Conference Session Chairs",
        "conference_session_chair"
      )}

      {renderSection(
        "New Program Developments",
        "new_program_development"
      )}

      {renderNewDegreeCourseDevelopment()}

      {renderSection(
        "International Academic Affiliation/Contribution",
        "international_academic_contribution"
      )}
    </div>
  );
}